import React from "react";
import { Link, useLocation } from "react-router-dom";
import "@fontsource/inter"; // Defaults to weight 400
import "@fontsource/inter/700.css"; // Specific weight

const Breadcrumb = ({ textColor = "#000" }) => {
  const location = useLocation();
  
  const breadcrumbMap = {
    // You can map specific routes to custom breadcrumb labels here

    "/Blog/ChoosetheRightTemplolinePark": "Choose the Right Temploline Park",
    "/Blog/2": "Process of Trampoline Park",
    "/Blog/3": "Trampoline Parks are Booming",
    "/Blog/4": "Indoor Playground Manufacturer",
    "/Blog/5": "Indoor Playground Business",
    "/Blog/6": "Schools Are Choosing Indoor Playgrounds",
    "/Blog/7": "Schools Are Choosing Indoor Playgrounds",
    "/Blog/8": "Schools Are Choosing Indoor Playgrounds",
    "/Blog/9": "Schools Are Choosing Indoor Playgrounds",
  };

  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <div style={{ 
      padding: "10px 20px", 
      fontFamily: "'Inter', sans-serif", 
      fontSize: "14px", 
      fontWeight: 500, 
      lineHeight: "30px", 
      letterSpacing: "0%" 
    }}>
      <nav>
        <Link to="/" style={{ 
          textDecoration: "none", 
          color: textColor, // Dynamic text color for Home
        }}>
          Home
        </Link>
        {pathnames.map((path, index) => {
          const url = `/${pathnames.slice(0, index + 1).join("/")}`;
          const isCurrentPage = index === pathnames.length - 1;

            // Use custom label from breadcrumbMap or fallback to default
          //  const label = breadcrumbMap[url] || path.replace("-", " ");

          return (
            <span key={url} style={{ margin: "0 1px", color: textColor }}>  
              {" < "} {/* Apply textColor to the separator */}
              <Link 
                to={url} 
                style={{ 
                  textDecoration: "none", 
                  color: isCurrentPage ? "#D0064B" : textColor, // Apply dynamic color
                  fontWeight: isCurrentPage ? "600" : "normal",
                  fontFamily: "'Inter', sans-serif",
                  fontSize: "14px",
                  lineHeight: "30px",
                  letterSpacing: "0%",
                  marginLeft: "0px" // Adds spacing after "<"
                }}
              >
                {breadcrumbMap[url] || path.replace("-", " ")}
              </Link>
            </span>
          );
        })}
      </nav>
    </div>
  );
};

export default Breadcrumb;
